module.exports = __webpack_public_path__ + "img/PEMEX.499d6b53.svg";